import { Commit } from 'vuex';
import { DashboardFournisseurState } from '.';

export interface DashboardFournisseurActionType {
    commit: Commit;
    state: DashboardFournisseurState;
    getters: any;
}

export enum DashboardFournisseurActions {
    GET_STATS = 'GET_STATS',
    GET_CINQ_DERNIERS_REGLEMENTS = 'GET_CINQ_DERNIERS_REGLEMENTS'
}
